import React, { Component } from "react";
import { message, Popconfirm, Tooltip, Space } from "antd";
import {
  EditOutlined,
  StopOutlined,
  CheckCircleOutlined,
  PlusOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  LockOutlined,
  SortAscendingOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, TableItem, SegmentedItem, MensajeError } from "../../../../Components/Items";
import ModalEtapaOrdenProduccionPU from "./ModalEtapaOrdenProduccionPU/ModalEtapaOrdenProduccionPU";
import DiagramaEtapasPU from "./DiagramaEtapasPU";
import { iconoDeEtapa, colorDeEtapa } from "./etapaVisual.utils";

class EtapasProduccionCrud extends Component {
  state = {
    loadingEtapas: false,
    etapas: [],
    modalEtapaVisible: false,
    etapaId: null,
    vista: "diagrama",
  };

  componentDidMount() {
    this.cargarEtapas();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scope?.flujoId !== this.props.scope?.flujoId) {
      this.setState({ etapas: [], modalEtapaVisible: false, etapaId: null });
      this.cargarEtapas();
    }
  }

  cargarEtapas = () => {
    this.setState({ loadingEtapas: true });
    axios
      .post(
        "etapasOrdenProduccionPU/selectTodasEtapas",
        { empresaId: this.props.empresaId, valor: 3, ...this.props.scope },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingEtapas: false });
        if (res.data.success === 2) {
          this.setState({ etapas: res.data.etapas || [] });
        } else {
          MensajeError({ message: "Error al cargar las etapas" });
        }
      })
      .catch(() => {
        this.setState({ loadingEtapas: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  abrirModalEtapa = (etapaId = null) => {
    this.setState({ modalEtapaVisible: true, etapaId });
  };

  cerrarModalEtapa = () => {
    this.setState({ modalEtapaVisible: false, etapaId: null });
    this.cargarEtapas();
  };

  cambiarEstadoEtapa = (etapaId, estado) => {
    const accion = estado === 1 ? "habilitarEtapa" : "deshabilitarEtapa";
    axios
      .post(`etapasOrdenProduccionPU/${accion}`, { etapaId, empresaId: this.props.empresaId, ...this.props.scope }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success(estado === 1 ? "Etapa habilitada" : "Etapa deshabilitada");
        } else {
          MensajeError({ message: "No se pudo actualizar la etapa" });
        }
        this.cargarEtapas();
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  eliminarEtapa = (etapaId) => {
    axios
      .post("etapasOrdenProduccionPU/eliminarEtapa", { etapaId, empresaId: this.props.empresaId, ...this.props.scope }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Etapa eliminada correctamente");
          this.cargarEtapas();
        } else {
          MensajeError({ message: res.data.error || "No se pudo eliminar la etapa" });
        }
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  guardarOrdenEtapas = (ordenes) => {
    this.setState({ loadingEtapas: true });
    axios
      .post("etapasOrdenProduccionPU/reordenarEtapas", { empresaId: this.props.empresaId, ordenes, ...this.props.scope }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.cargarEtapas();
        } else {
          MensajeError({ message: res.data.error || "No se pudo reordenar" });
          this.setState({ loadingEtapas: false });
        }
      })
      .catch(() => {
        MensajeError({ message: "Error al conectar con el servidor" });
        this.setState({ loadingEtapas: false });
      });
  };

  moverEtapa = (index, direccion) => {
    const etapas = [...this.state.etapas];
    const otro = index + direccion;
    if (otro < 0 || otro >= etapas.length) return;
    [etapas[index], etapas[otro]] = [etapas[otro], etapas[index]];
    this.guardarOrdenEtapas(etapas.map((e, i) => ({ etapaId: e._id, orden: i })));
  };

  ordenarEtapasPorTransicion = () => {
    const etapas = this.state.etapas;
    const porId = new Map(etapas.map((e) => [e._id, e]));
    const visitadas = new Set();
    const ordenFinal = [];

    const inicial = etapas.find((e) => e.esInicial);
    const cola = inicial ? [inicial._id] : [];

    while (cola.length > 0) {
      const id = cola.shift();
      if (visitadas.has(id)) continue;
      visitadas.add(id);
      const etapa = porId.get(id);
      if (!etapa) continue;
      ordenFinal.push(id);
      (etapa.transiciones || []).forEach((t) => {
        const destinoId = t.etapaDestinoId?._id || t.etapaDestinoId;
        if (destinoId && !visitadas.has(destinoId)) cola.push(destinoId);
      });
    }

    etapas.forEach((e) => {
      if (!visitadas.has(e._id)) ordenFinal.push(e._id);
    });

    this.guardarOrdenEtapas(ordenFinal.map((etapaId, index) => ({ etapaId, orden: index })));
  };

  render() {
    const hayAlgunaAccion =
      this.props.permisoReordenarEtapas ||
      this.props.permisoEditarEtapa ||
      this.props.permisoDeshabilitarEtapa ||
      this.props.permisoEliminarEtapa;
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        render: (nombre, record) => (
          <Space>
            <span style={{ color: colorDeEtapa(record) }}>{iconoDeEtapa(record)}</span>
            {nombre} {record.protegida && <LockOutlined style={{ color: "#8c8c8c" }} />}
          </Space>
        ),
      },
      { title: "Descripción", dataIndex: "descripcion", key: "descripcion" },
      ...[
            {
              title: "Fases anteriores",
              key: "fasesAnteriores",
              render: (_, record) =>
                this.state.etapas
                  .filter((e) => (e.transiciones || []).some((t) => (t.etapaDestinoId?._id || t.etapaDestinoId) === record._id))
                  .map((e) => e.nombre)
                  .join(", ") || "Ninguna",
            },
            {
              title: "Fases siguientes",
              dataIndex: "transiciones",
              key: "fasesSiguientes",
              render: (transiciones) =>
                (transiciones || [])
                  .map((t) => t.etiqueta || t.etapaDestinoId?.nombre)
                  .filter(Boolean)
                  .join(", ") || "Ninguna",
            },
          ],
      ...(this.props.soloLectura || !hayAlgunaAccion
        ? []
        : [
            {
              title: "Acción",
              key: "accion",
              align: "center",
              render: (_, record, index) => (
                <>
                  {this.props.permisoReordenarEtapas && (
                    <>
                      <Tooltip title="Subir">
                        <ButtonItem type="default" size="small" blanco disabled={index === 0} icon={<ArrowUpOutlined />} onClick={() => this.moverEtapa(index, -1)} />
                      </Tooltip>{" "}
                      <Tooltip title="Bajar">
                        <ButtonItem
                          type="default"
                          size="small"
                          blanco
                          disabled={index === this.state.etapas.length - 1}
                          icon={<ArrowDownOutlined />}
                          onClick={() => this.moverEtapa(index, 1)}
                        />
                      </Tooltip>{" "}
                    </>
                  )}
                  {this.props.permisoEditarEtapa && (
                    <Tooltip title="Editar">
                      <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrirModalEtapa(record._id)} />
                    </Tooltip>
                  )}{" "}
                  {this.props.permisoDeshabilitarEtapa &&
                    (record.estado === 1 ? (
                      record.protegida ? (
                        <Tooltip title="Etapa protegida: no se puede deshabilitar">
                          <ButtonItem type="default" size="small" disabled icon={<CheckCircleOutlined />} />
                        </Tooltip>
                      ) : (
                        <Popconfirm title="¿Deshabilitar esta etapa?" onConfirm={() => this.cambiarEstadoEtapa(record._id, 2)}>
                          <Tooltip title="Deshabilitar">
                            <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                          </Tooltip>
                        </Popconfirm>
                      )
                    ) : (
                      <Popconfirm title="¿Habilitar esta etapa?" onConfirm={() => this.cambiarEstadoEtapa(record._id, 1)}>
                        <Tooltip title="Habilitar">
                          <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                        </Tooltip>
                      </Popconfirm>
                    ))}{" "}
                  {this.props.permisoEliminarEtapa &&
                    (record.protegida ? (
                      <Tooltip title="Etapa protegida: no se puede eliminar">
                        <ButtonItem type="default" size="small" disabled icon={<DeleteOutlined />} />
                      </Tooltip>
                    ) : (
                      <Popconfirm title="¿Eliminar esta etapa? Solo se puede si no está en uso por ninguna orden." onConfirm={() => this.eliminarEtapa(record._id)}>
                        <Tooltip title="Eliminar">
                          <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                        </Tooltip>
                      </Popconfirm>
                    ))}
                </>
              ),
            },
          ]),
    ];

    return (
      <>
        <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <SegmentedItem
            value={this.state.vista}
            onChange={(vista) => this.setState({ vista })}
            options={[
              { label: "Diagrama", value: "diagrama" },
              { label: "Tabla", value: "tabla" },
            ]}
          />
          {!this.props.soloLectura && (
            <div>
              {this.props.permisoReordenarEtapas && (
                <Tooltip title="Reordena las etapas siguiendo el flujo real de transiciones, empezando en la etapa inicial. Las que ninguna transición alcanza quedan al final.">
                  <ButtonItem icon={<SortAscendingOutlined />} onClick={this.ordenarEtapasPorTransicion} style={{ marginRight: 8 }}>
                    Ordenar por transición
                  </ButtonItem>
                </Tooltip>
              )}
              {this.props.permisoAgregarEtapa && (
                <ButtonItem type="primary" olivo icon={<PlusOutlined />} onClick={() => this.abrirModalEtapa()}>
                  Agregar etapa
                </ButtonItem>
              )}
            </div>
          )}
        </div>

        {this.state.vista === "diagrama" ? (
          <DiagramaEtapasPU
            etapas={this.state.etapas}
            scope={this.props.scope}
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            puedeEditar={!this.props.soloLectura}
            onAbrirEtapa={this.props.permisoEditarEtapa && !this.props.soloLectura ? this.abrirModalEtapa : undefined}
            onGuardado={this.cargarEtapas}
          />
        ) : (
          <TableItem loading={this.state.loadingEtapas} size="small" dataSource={this.state.etapas} columns={columns} rowKey="_id" />
        )}

        <ModalEtapaOrdenProduccionPU
          visible={this.state.modalEtapaVisible}
          etapaId={this.state.etapaId}
          etapasDisponibles={this.state.etapas}
          scope={this.props.scope}
          cerrarModal={this.cerrarModalEtapa}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoAgregarEtapa:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b3076e58adfd453df65c8")?.activado,
  permisoEditarEtapa:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b3083e58adfd453df65c9")?.activado,
  permisoDeshabilitarEtapa:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b3094e58adfd453df65cb")?.activado,
  permisoEliminarEtapa:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b30a4e58adfd453df65f1")?.activado,
  permisoReordenarEtapas:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b30c6e58adfd453df6605")?.activado,
});

export default connect(mapStateToProps)(EtapasProduccionCrud);
